export default "__VITE_PUBLIC_ASSET__db88c5ff__"